export const submittedApplication = {
  title: 'Your Application Is Submitted!',
  content: 'You will receive a confirmation mail as soon as your application gets accepted.',
  otherContent: 'Contact us - support@oswb.org',
  buttonsTitle: ['Logout'],
};

export const ratifiedApplication = {
  TITLE: 'Congratulations!',
  CONTENT:
    'Your profile has been ratified. Your mebership id is being created and will be emailed to you. Once you have the membership id, you can login on this portal as a Member.',
  BUTTONS_TITLE: ['Logout'],
};

export const proposalResponse = {
  SUCCESS: 'accepted',
  FAIL: 'rejected',
  WAIT: 'pending',
};

export const applicationStatus = {
  AWAIT_RESPONSE: 'awaiting_response',
  PROPOSER_REJECTED: 'proposer_rejected',
  SECONDER_REJECTED: 'seconder_rejected',
  AWAIT_MEMBERSHIP_ID: 'awaiting_membership_id',
  REJECT_LIST: ['both_rejected', 'rejected'],
  WITHDRAWN: 'withdrawn',
  MEMBER: 'member',
};

export const ratifierResponseAwaitList = [
  'awaiting_proposer_response',
  'awaiting_seconder_response',
];

export const rejectedApplication = {
  TITLE: 'We are sorry!',
  CONTENT: `We regret to inform you that your submitted application has been rejected. 
    We appreciate your participation and thank you for your interest in our program.`,
  BUTTONS_TITLE: ['Close'],
};

export enum ratificationStatusTagColor {
  REJECTED = '#F8BCBC',
  APPROVED = '#C2D2BC',
  PENDING = '#F8D1BC',
}

export const badgeData = [
  {
    name: 'SHELL_APPLICATION',
    backgroundColor: '#3498db',
    color: 'white',
    text: 'Draft Application',
  },
  {
    name: 'AWAITING_PAYMENT',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Payment',
  },
  {
    name: 'SELECTING_PROPOSER_SECONDER',
    backgroundColor: '#F8D1BC',
    color: 'black',
    text: 'Selecting Proposer/Seconder',
  },
  {
    name: 'AWAITING_PROPOSAL_RESPONSE',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Proposal Response',
  },
  {
    name: 'AWAITING_PROPOSER_RESPONSE',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Proposer Response',
  },
  {
    name: 'AWAITING_SECONDER_RESPONSE',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Seconder Response',
  },
  {
    name: 'AWAITING_RESPONSE',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Response',
  },
  {
    name: 'AWAITING_MEMBERSHIP_ID',
    backgroundColor: '#FAF7AE',
    color: 'black',
    text: 'Awaiting Membership ID',
  },
  {
    name: 'MEMBER',
    backgroundColor: 'white',
    color: 'black',
    text: 'Member',
    border: 'black',
  },
  {
    name: 'WITHDRAWN',
    backgroundColor: 'black',
    color: 'white',
    text: 'Withdrawn',
  },
  {
    name: 'APPROVED',
    backgroundColor: 'lightgreen',
    color: 'white',
    text: 'Approved',
  },
  {
    name: 'ACCEPTED',
    backgroundColor: 'lightgreen',
    color: 'white',
    text: 'Accepted',
  },
  {
    name: 'REJECTED',
    backgroundColor: 'red',
    color: 'white',
    text: 'Rejected',
  },
  {
    name: 'PROPOSER_REJECTED',
    backgroundColor: 'red',
    color: 'white',
    text: 'Proposer Rejected',
  },
  {
    name: 'SECONDER_REJECTED',
    backgroundColor: 'red',
    color: 'white',
    text: 'Seconder Rejected',
  },
  {
    name: 'BOTH_REJECTED',
    backgroundColor: 'red',
    color: 'white',
    text: 'Both Rejected',
  },
  {
    name: 'ADMIN',
    backgroundColor: '#34495E',
    color: '#ECF0F1',
    text: 'Admin',
  },
];
export const noData = {
  TITLE: 'No Result Found',
  SUB_TITLE:
    'We are sorry, but the details you entered do not match our search requirements. Please check your entries and try again.',
};

export const errorDialog = {
  TITLE: 'Error!',
  CONTENT: 'Please select a membership plan to proceed',
  BUTTONS_TITLE: ['OK'],
};

export const offlineDialog = {
  TITLE: 'Pay Offline',
  CONTENT: 'Are you sure, you want to proceed with offline payment?',
  BUTTONS_TITLE: ['yes', 'cancel'],
};

export const successPaymentDialog = {
  TITLE: 'Congratulations!',
  BUTTONS_TITLE: ['proceed'],
};

export const failPaymentDialog = {
  TITLE: 'Payment Failed!',
  CONTENT: 'We regret to inform you that your payment has been failed.',
  BUTTONS_TITLE: ['Try again'],
};

export const paymentStatus = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAILED',
};

export const membershipTierToastMessage = {
  UPDATE_MEMBERSHIP_PLAN: 'Membership plan selected successfully!',
  PAYMENT_FAILED: 'Payment is not completed!',
  NO_INTERNET: 'Please check your internet connection!',
};

export const helpCard = {
  TITLE: 'Contact us at',
  NAME: 'Apurba Adhikary',
  EMAIL: 'support@oswb.org',
  CONTACT: '+91 9836340743',
};

export const RATIFIER_TYPES = ['PROPOSER', 'SECONDER'];

export const rejectApplicationDialog = {
  TITLE: 'Are you sure you want to reject?',
  FIELD: {
    NAME: 'applicationRejectReason',
    LABEL: 'State Reason (Optional)',
    PLACEHOLDER: 'Please write a short reason so that we can inform the member.',
  },
  BUTTONS_TITLE: ['Submit', 'Skip'],
};

export const approveApplicationDialog = {
  TITLE: 'Approve Application',
  CONTENT: 'Are you sure you want to approve the application?',
  BUTTONS_TITLE: ['yes', 'cancel'],
};

export const SEND_REMINDER = {
  TITLE: 'send reminder all',
  CONTENT: 'Are you sure , you want to send the email reminder to all selected users?',
  OTHER_CONTENT: 'Selected Users Count',
  BUTTONS_TITLE: ['send', 'cancel'],
};

export const ADMIN_REMINDER_FILTERS = {
  LIFECYCLE_OPTIONS: [
    { label: 'All', value: 'All' },
    { label: 'Shell Application', value: 'SHELL_APPLICATION' },
    { label: 'Proposer Pending', value: 'AWAITING_PROPOSER_RESPONSE' },
    { label: 'Seconder Pending', value: 'AWAITING_SECONDER_RESPONSE' },
    { label: 'Sent to Ratification', value: 'SELECTING_PROPOSER_SECONDER' },
  ],
  LIFECYCLE_PLACEHOLDER: 'Lifecycle',
  SELECT_ALL_LABEL: 'Select All',
  SEARCH: {
    BUTTON_TEXT: 'Search',
    PLACEHOLDER: 'Search by name or specialisation',
  },
};

export const REMINDER_APPLICANT_CARD = {
  BUTTON_TEXT: 'Send Reminder',
  USER_STATUS_AT_RATIFICATION: {
    COLOR: '#000',
    BACKGROUND_COLOR: '#F8D1BC',
  },
  USER_STATUS: {
    COLOR: '#000',
    BACKGROUND_COLOR: '#D6D9EB',
  },
};

export const PROPOSAL_AUTOCOMPLETE = {
  PROPOSER: {
    LABEL: 'Enter Proposer name',
    PLACEHOLDER: 'Enter name',
  },
  SECONDER: {
    LABEL: 'Enter Seconder name',
    PLACEHOLDER: 'Enter name',
  },
};

export const RATIFICATION_STATUS_AUTOCOMPLETE = {
  PROPOSER: {
    LABEL: 'Select another proposer',
    PLACEHOLDER: 'Enter name',
  },
  SECONDER: {
    LABEL: 'Select another seconder',
    PLACEHOLDER: 'Enter name',
  },
};

export const RATIFIER_APPLICATION_STATUS_LIST = [
  'AWAITING_SECONDER_RESPONSE',
  'AWAITING_RESPONSE',
  'AWAITING_PROPOSER_RESPONSE',
];

export const NO_RESULT_CONTENT = {
  TITLE: 'Please enter member name to select Proposer/Seconder',
  GROUP_TITLE: 'Please enter member name to add in group',
};
export const defaultCountry = 'India';
export const defaultCountryCode = '+91';
export const rejectStatusArray = ['WITHDRAWN', 'MEMBER', 'REJECTED'];
export const smallScreenWidth = 1001;
export const DOCTOR_PREFIX_LIST = ['Dr.', 'Dr', 'Doctor', 'Dr,', 'Doc'];

export const allStatus = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  SHELL_APPLICATION: 'SHELL_APPLICATION',
  DRAFT_APPLICATION: 'DRAFT_APPLICATION',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  SELECTING_PROPOSER_SECONDER: 'SELECTING_PROPOSER_SECONDER',
  AWAITING_PROPOSAL_RESPONSE: 'AWAITING_PROPOSAL_RESPONSE',
  AWAITING_PROPOSER_RESPONSE: 'AWAITING_PROPOSER_RESPONSE',
  AWAITING_SECONDER_RESPONSE: 'AWAITING_SECONDER_RESPONSE',
  AWAITING_RESPONSE: 'AWAITING_RESPONSE',
  AWAITING_MEMBERSHIP_ID: 'AWAITING_MEMBERSHIP_ID',
  WITHDRAWN: 'WITHDRAWN',
  APPROVED: 'APPROVED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PROPOSER_REJECTED: 'PROPOSER_REJECTED',
  SECONDER_REJECTED: 'SECONDER_REJECTED',
  BOTH_REJECTED: 'BOTH_REJECTED',
};

export const proposerSeconderEditableState = [
  'AWAITING_PROPOSER_RESPONSE',
  'AWAITING_PROPOSAL_RESPONSE',
  'AWAITING_SECONDER_RESPONSE',
  'AWAITING_RESPONSE',
  'PENDING',
  'REJECTED',
];

export const REASSIGNED_RATIFIER_CONTENT = {
  PROPOSER: 'Proposer is reassigned by admin',
  SECONDER: 'Seconder is reassigned by admin',
};

export const CLIENT_STORE = {
  PAYMENT_MODE: 'payment-mode',
  PAYMENT_STATUS: 'payment-status',
  ONLINE: 'online',
  SUCCESS: 'success',
  USER_LIFE_CYCLE_STATUS: 'user-life-cycle-status',
  APPLICATION_STATUS: 'application-status',
  OFFLINE: 'offline',
  INITIATE: 'initiated',
  AWAIT_PAYMENT: 'awaiting_payment',
  SELECT_PROPOSER_SECONDER: 'selecting_proposer_seconder',
  IS_ADMIN: 'is-admin',
  CURRENT_STEP: 'current-step',
  MEMBER: 'member',
  WITHDRAWN: 'withdrawn',
  API_TOKEN: 'api-token',
  USER_ID: 'user-id',
  IS_FIRST_USER: 'is-first-time-user',
  USER_DETAILS: 'user-details',
  FALSE: 'false',
};
export const GROUP_TYPE_FILTER_OPTION_LIST = [
  { label: 'All', value: '' },
  { label: 'Public Group', value: 'PUBLIC' },
];
export const GROUP_TYPE_FILTER_OPTION_LIST_MEMBER = [
  ...GROUP_TYPE_FILTER_OPTION_LIST,
  { label: 'My Group', value: 'SELF' },
];
export const GROUP_SEARCH_BAR_PLACEHOLDER = 'Search by group name';
export const PAGINATION = { CURRENT_PAGE: 1, PAGE_SIZE: 10, TOTAL_PAGE: 1 };
export const API_ERROR = { MESSAGE: 'Network Error' };

export const roleOptions = [
  {
    label: 'Head',
    value: 'head',
  },
  {
    label: 'Chairperson',
    value: 'chairperson',
  },
  {
    label: 'Secretary',
    value: 'Secretary',
  },
  {
    label: 'Member',
    value: 'member',
  },
];
export const GROUP_TYPE_FILTER_OPTION_LIST_ADMIN = [
  ...GROUP_TYPE_FILTER_OPTION_LIST,
  { label: 'Private Group', value: 'PRIVATE' },
];

export const GROUP_STATUS_FILTER_OPTION_LIST = [
  { label: 'All', value: '' },
  { label: 'Active Group', value: 'True' },
  { label: 'Inactive Group', value: 'False' },
];

export const GROUP_FILTER = {
  GROUP_TYPE: 'GROUP_TYPE',
  GROUP_STATUS: 'GROUP_STATUS',
  GROUP_TYPE_LABEL: 'Group Type',
  GROUP_STATUS_LABEL: 'Group Status',
  EMPTY_VALUE: '',
};

export const SELECT_FIELD_WIDTH = {
  DESKTOP: '500px',
  WIDTH_BELOW_575: '350px',
  BREAK_POINTS: [575, 1000],
};

export const SEARCH_BAR = {
  PLACEHOLDER: 'Search members by name, membership number or specialisation',
};

export const TAB_PANEL = {
  PERSONAL: 'personal',
  MEMBERSHIP: 'membership',
};
